import { Image, QRCode, Modal } from "antd";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";

const AddPmisplusLoginFields = (props) => {
    const shouldShow = shouldShowComponent(config.project, "AddPmisplusLoginFields");

    if (!shouldShow) {
        return null; // Do not render if the condition is not met
    }

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                    paddingTop: "8px",
                }}

            >
                {" "}
                <Image
                    // className="appStoreImage"
                    preview={false}
                    width={150}
                    style={{
                        cursor: "pointer",
                        // width: "185px",
                    }}
                    src={require("../../../assets/images/app-images/google-play-btn.png")}
                    onClick={() => {
                        props.handleGoogleStates();

                    }}
                ></Image>

                <Image
                    preview={false}
                    width={150}
                    style={{
                        cursor: "pointer",
                        // width: "185px",
                    }}
                    src={require("../../../assets/images/app-images/app-store-btn.png")}
                    onClick={() => {
                        props.handleAppleStates();
                    }}
                ></Image>

            </div>


            <Modal
                open={props.This.openModalForQRCode}
                // onCancel={() => this.setState({ openModalForQRCode: false })}
                onCancel={props.closeqrPopup}
                footer={null}
                title="Scan QRCode to Download App!"
                width={350}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                >
                    {props.This.showGoogleQRCode && (
                        <div style={{ marginTop: 20, alignItems: "center" }}>
                            <QRCode value="https://play.google.com/store/apps/details?id=com.pmis.starling&pcampaignid=web_share" />
                        </div>
                    )}

                    {props.This.showQRCode && (
                        <div style={{ marginTop: 20, alignItems: "center" }}>
                            <QRCode value="https://apps.apple.com/ae/app/trackeazy-starling-eye/id6755625106" />
                        </div>
                    )}
                </div>
            </Modal>
        </>
    );
};

AddPmisplusLoginFields.contextType = StoreContext;
export default observer(withRouter(AddPmisplusLoginFields));
